var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GENERIC_FORBIDDEN_MESSAGE, GENERIC_UNKNOWN_ERROR_MESSAGE, HttpStatusCode } from '@/data/protocols/http';
export class RemoteOpenPolicy {
    constructor(url, client) {
        this.url = url;
        this.httpClient = client;
    }
    validate(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const httpResponse = yield this.httpClient.request({
                url: this.url,
                method: 'POST',
                body: params
            });
            switch (httpResponse.statusCode) {
                case HttpStatusCode.ok:
                    return makeModel(httpResponse.body, false);
                case HttpStatusCode.badRequest:
                    return makeModel(httpResponse.body, true);
                case HttpStatusCode.forbidden:
                    return makeModel(makeForbiddenError(), true);
                default:
                    return makeModel(makeUnknownError(), true);
            }
        });
    }
}
function makeErrorBody(code, errorMsg) {
    return {
        code: code,
        message: errorMsg,
        error: []
    };
}
function makeForbiddenError() {
    return makeErrorBody(HttpStatusCode.forbidden, GENERIC_FORBIDDEN_MESSAGE);
}
function makeUnknownError() {
    return makeErrorBody(HttpStatusCode.forbidden, GENERIC_UNKNOWN_ERROR_MESSAGE);
}
function makeModel(body, error) {
    return {
        error: error,
        data: body
    };
}
